<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-08 16:09:40
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-26 15:53:56
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/enterprise_home_page/components/card.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="enterpriseMainCard">
    <div class="controllBox">

      <div class="collect" @click="share">
        <i class="iconfont icon">{{`\ue6f5`}}</i>
      </div>
      <div class="collect" @click="collect">
        <i class="iconfont checkIcon" v-if="detail.isFollower">{{`\ue6e8` }}</i>
        <i class="iconfont icon" v-else>{{`\ue6d8` }}</i>
      </div>
    </div>
    <img :src="detail.logo" class="leftLogo" alt="">
    <div class="rightItem">
      <div class="name">
        <div class="text-ellipsis-2" style="width:180px"> {{detail.enterpriseName}}</div>
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/authGif/auth.gif" alt="" class="realIcon">
      </div>
      <div class="contactItem">
        <div class="follow">{{$t('lang.t250')}}： {{detail.followCount}}</div>
        <div class="contactUs" @click="contactUs">{{$t('lang.t251')}}</div>
      </div>
      <div class="desc text-ellipsis-3" @click="seeDetail">{{detail.introduction}}</div>
    </div>
    <div class="languageTips" v-if="language != 'CN'">
      {{languageWord}}
    </div>
  </div>
</template>

<script>
import { contactAddFollower, cancelEnterpriseFollower } from '@/api/interNational'
export default {
  name: 'card',
  props: {
    detail: {
      type: Object,
      default: {},
    },
    language: {
      type: String,
      default: 'CN',
    },
  },
  data() {
    return {}
  },
  computed: {
    languageWord() {
      let lag = this.languageList.filter((v) => v.languageKey == this.language)
      console.log(lag)
      if (lag.length > 0) {
        return lag[0].name
      } else {
        return ''
      }
    },
    languageList() {
      return [
        { name: this.$t('lang.t267'), languageName: '中文', languageKey: 'CN', check: false },
        { name: this.$t('lang.t268'), languageName: 'English', languageKey: 'EN', check: false },
        { name: this.$t('lang.t269'), languageName: 'Français', languageKey: 'FR', check: false },
        { name: this.$t('lang.t270'), languageName: 'Русский', languageKey: 'RU', check: false },
        { name: this.$t('lang.t271'), languageName: 'Español', languageKey: 'ES', check: false },
        { name: this.$t('lang.t272'), languageName: '日本語', languageKey: 'JA', check: false },
        { name: this.$t('lang.t273'), languageName: '한국어', languageKey: 'KO', check: false },
        { name: this.$t('lang.t274'), languageName: 'Bahasa Indonesia', languageKey: 'ID', check: false },
        { name: this.$t('lang.t275'), languageName: 'Tiếng Việt', languageKey: 'VI', check: false },
        { name: this.$t('lang.t276'), languageName: 'Deutsch', languageKey: 'DE', check: false },
        { name: this.$t('lang.t277'), languageName: 'Türkçe', languageKey: 'TR', check: false },
        { name: this.$t('lang.t278'), languageName: 'Italiano', languageKey: 'IT', check: false },
        { name: this.$t('lang.t279'), languageName: 'Português', languageKey: 'PT', check: false },
        { name: this.$t('lang.t280'), languageName: 'ภาษาไทย', languageKey: 'TH', check: false },
        { name: this.$t('lang.t281'), languageName: 'Bahasa Melayu', languageKey: 'MS', check: false },
        { name: this.$t('lang.t282'), languageName: 'بالعربية', languageKey: 'AR', check: false },
      ]
    },
  },

  mounted() {
    this.nativeShare = new NativeShare()
    var shareData = {
      title: 'AI 荟客厅',
      desc: 'AI 荟客厅',
      // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
      link: window.location.href,
      icon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/images/wemeet-logo.jpg',
    }
    this.nativeShare.setShareData(shareData)
  },

  methods: {
    isWeixinBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      return /micromessenger/.test(userAgent)
    },
    contactUs() {
      this.$isLogin().then((res) => {
        this.$emit('contactUs')
      })
    },
    seeDetail() {
      this.$dialog
        .alert({
          message: this.detail.introduction,
          confirmButtonColor: '#00c4c9',
          confirmButtonText: this.$t('lang.t120'),
        })
        .then(() => {
          //点击确认按钮后的调用
        })
    },
    share() {
      if (this.isWeixinBrowser()) {
        this.$emit('wxshare')
        return false 
      }
      try {
        this.nativeShare.call()
      } catch (err) {
        console.log(err)
      }
    },
    collect() {
      this.$isLogin().then((res) => {
        if (this.detail.isFollower) {
          cancelEnterpriseFollower({}, { enterpriseCode: this.detail.enterpriseCode }).then((res) => {
            this.$toast(this.$t('lang.t147'))
            this.$emit('refresh')
          })
        } else {
          let params = {
            enterpriseCode: this.detail.enterpriseCode,
            sceneCode: this.detail.enterpriseCode,
            sceneType: 'ENTERPRISES',
          }
          contactAddFollower({}, params).then((res) => {
            this.$toast(this.$t('lang.t146'))
            this.$emit('refresh')
          })
        }
      })
    },
  },
}
</script>


<style lang="less" scoped>
.enterpriseMainCard {
  width: 100%;
  min-height: 144px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  padding: 10px 10px 18px;
  box-sizing: border-box;
  position: relative;
  padding-top: 30px;
  .languageTips {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 12px;
    background: #d1feff;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 10px;
    padding: 0 7px;
    box-sizing: border-box;
    color: #00c4c9;
  }
  .controllBox {
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    .collect {
      width: 32px;
      height: 32px;
      background: #fff;
      align-items: center;
      display: flex;
      justify-content: center;
      border-radius: 50%;
      margin-right: 5px;
      .icon {
        font-size: 24px;
        color: #333;
      }
      .checkIcon {
        color: #00c4c9;
        font-size: 24px;
      }
    }
  }
  .leftLogo {
    width: 75px;
    height: 75px;
  }
  .rightItem {
    width: calc(100% - 95px);
    margin-left: 10px;
    .name {
      color: #262626;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .realIcon {
        width: 15px;
        height: 15px;
      }
    }
    .contactItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .follow {
        font-size: 12px;
        color: #595959;
      }
      .contactUs {
        min-width: 60px;
        height: 22px;
        border-radius: 5px;
        border: 1px solid #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 8px;
        box-sizing: border-box;
      }
    }
    .desc {
      color: #999;
      font-size: 12px;
      margin-top: 10px;
      min-height: 40px;
      width: 100%;
    }
  }
}
</style>